module.exports = __webpack_public_path__ + "static/media/TapThinRoot3.ec79ff65.PNG";